import { makeStyles, mergeClasses } from '@fluentui/react-components';
import { tokens } from '@fluentui-copilot/tokens';
import type { GroundingMenuSlots, GroundingMenuState } from './GroundingMenu.types';
import type { SlotClassNames } from '@fluentui/react-components';

export const groundingMenuClassNames: SlotClassNames<GroundingMenuSlots> = {
  root: 'fai-GroundingMenu',
};

export const GROUNDING_MENU_GRID_AREAS = {
  commandBar: 'commandBar',
  listbox: 'listbox',
};

// Height of a single item plus padding
const GROUNDING_MENU_LISTBOX_MIN_HEIGHT = `calc(48px + (2 * ${tokens.spacingVerticalS}))`;
// Max height of the listbox as defined by design spec
const GROUNDING_MENU_LISTBOX_MAX_HEIGHT = `272px`;

/**
 * Styles for the root slot
 */
const useStyles = makeStyles({
  root: {
    boxShadow: tokens.shadow8,
    borderRadius: '12px', // TODO: Use a token when available
    maxHeight: '80vh',
    boxSizing: 'border-box',
    border: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke1}`,
    overflowX: 'hidden',
    display: 'grid',
    gridTemplateAreas: `"${GROUNDING_MENU_GRID_AREAS.commandBar}"
    "${GROUNDING_MENU_GRID_AREAS.listbox}"`,
    gridTemplateRows: `auto minmax(${GROUNDING_MENU_LISTBOX_MIN_HEIGHT}, ${GROUNDING_MENU_LISTBOX_MAX_HEIGHT})`,
    gridTemplateColumns: '1fr',
  },
});

/**
 * Apply styling to the GroundingMenu slots based on the state
 */
export const useGroundingMenuStyles_unstable = (state: GroundingMenuState): GroundingMenuState => {
  'use no memo';

  const styles = useStyles();
  state.root.className = mergeClasses(groundingMenuClassNames.root, styles.root, state.root.className);

  return state;
};
